import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { TicketTypesConfigEntrypoint } from '@jira/spa-apps__project-settings-service-desk-ticket-types-config/src/TicketTypesConfigEntrypoint.entrypoint.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskIssueTypesResource } from '@jira/router-resources__service-desk-issue-types/src/servicedeskIssueTypesResource.tsx';
import { servicedeskPortalGroupsResource } from '@jira/router-resources__service-desk-portal-groups/src/servicedeskPortalGroupsResource.tsx';
import { servicedeskPracticesResource } from '@jira/router-resources__service-desk-practices/src/useWorkCategoriesAllSupported.tsx';
import { featuresResource } from '@jira/router-resources__service-project-features/src/featuresResource.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { projectSettingsServicedeskTicketTypesConfigRoute } from '@jira/router-routes__project-settings-service-desk-ticket-types-config-routes/src/projectSettingsServicedeskTicketTypesConfigRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ServiceDeskTicketTypesConfig, {
	LazyProjectSettingsServiceDeskTicketTypesConfig,
} from './ui/service-desk-ticket-types-config/index.tsx';

const projectSettingsServicedeskTicketTypesConfigPageEntrypoint = createPageEntryPoint({
	main: TicketTypesConfigEntrypoint,
});

export const projectSettingsServicedeskTicketTypesConfigRouteEntry: Route = createEntry(
	projectSettingsServicedeskTicketTypesConfigRoute,
	() => ({
		group: 'project-settings-servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskTicketTypesConfig,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			servicedeskPracticesResource,
			servicedeskIssueTypesResource,
			servicedeskPortalGroupsResource,
			getConsolidationStateResource(),
			featuresResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskTicketTypesConfig],

		entryPoint() {
			return projectSettingsServicedeskTicketTypesConfigPageEntrypoint;
		},

		meta: {
			reporting: {
				id: APP_NAMES.REQUEST_TYPES_CONFIG,
				packageName: toPackageName(APP_NAMES.REQUEST_TYPES_CONFIG),
				teamName: 'jsd-shield',
			},
		},

		perfMetricKey: 'jsm-request-types-configuration',
		ufoName: 'jsm-request-types-configuration',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
